import * as React from 'react';
import './passwordChangePane.module.scss';
import classNames from 'classnames';
import { observer } from 'mobx-react';
import { inject } from 'mobx-react';
import { HomePageState } from '../../../containers/home/states/HomePageState';
import { observable } from 'mobx';
import { SideBar } from './SideBar';
import { V3Routes } from '../../../routes';
import { GlobalStatesV3 } from '../../../../commonv3/states/GlobalStatesV3';
import { BackButtonHeader } from './BackButtonHeader';
import { FormInput } from '../../atoms/forms/FormInput';
import { PasswordChangePaneState } from './states/PasswordChangePaneState';

type ButtonProps = {
    children: any;
    disabled?: boolean;
    onClick?: () => void;
};

const Button = observer(({ children, disabled, onClick }: ButtonProps) => {
    return (
        <div
            styleName={classNames('button', { disabled: disabled })}
            onClick={!disabled && onClick ? onClick : undefined}
        >
            {children}
        </div>
    );
});

type Props = {
    homeState: HomePageState;
};

@inject('homeState')
@observer
export class PasswordChangePane extends React.Component<Props> {
    @observable pageState = new PasswordChangePaneState();

    render() {
        const { submitting, formState } = this.pageState;
        return (
            <div styleName="pane">
                {GlobalStatesV3.viewport.isDesktop && <SideBar activeMenu="password" />}
                <div styleName="main">
                    {GlobalStatesV3.viewport.isSp && <BackButtonHeader to={V3Routes.myPage()} />}
                    <h1 styleName="h1">パスワードの変更</h1>
                    <div styleName="form-label">現在のパスワード</div>
                    <FormInput
                        type="password"
                        styleName="current_password"
                        name="current_password"
                        value={formState.getValue('current_password')}
                        placeholder=""
                        onChange={(e) => formState.setValue('current_password', e.target.value)}
                        error={formState.getError('current_password')}
                    />
                    {/*
                    <div styleName="forget-password">
                        <a>※パスワードを忘れた方はこちら</a>
                    </div>
                    */}
                    <div styleName="form-label">新しいパスワード</div>
                    <FormInput
                        type="password"
                        styleName="password"
                        name="password"
                        value={formState.getValue('password')}
                        placeholder=""
                        onChange={(e) => formState.setValue('password', e.target.value)}
                        error={formState.getError('password')}
                    />
                    <div styleName="form-label">新しいパスワードを再入力</div>
                    <FormInput
                        type="password"
                        styleName="password_confirmation"
                        name="password_confirmation"
                        value={formState.getValue('password_confirmation')}
                        placeholder=""
                        onChange={(e) => formState.setValue('password_confirmation', e.target.value)}
                        error={formState.getError('password_confirmation')}
                    />
                    <div styleName="form-submit-button">
                        <Button disabled={submitting} onClick={() => this.pageState.submit()}>
                            保存する
                        </Button>
                    </div>
                </div>
            </div>
        );
    }
}
